import { DefaultSectionCopy, Section } from "@hydrologiq/shared/providers/CopyProvider"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"

const copy: DefaultSectionCopy = {
  type: Section.ASSETS,
  name: "Assets",
  base: "assets",
  routes: [],
  buttons: [
    { name: COPY_KEYS.BUTTONS.CREATE, label: "Create Asset", description: "Add a new asset to the system" },
    { name: COPY_KEYS.BUTTONS.ARCHIVE, label: "Delete this asset", description: "Delete the current asset" },
    { name: COPY_KEYS.BUTTONS.EDIT, label: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.EDIT], description: "Edit asset" },
    { name: COPY_KEYS.BUTTONS.SAVE, label: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.SAVE], description: "Save changes" },
    {
      name: COPY_KEYS.BUTTONS.CANCEL,
      label: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.CANCEL],
      description: "Cancel changes",
    },
  ],
  headings: [
    { name: COPY_KEYS.HEADINGS.ASSET, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSET] },
    { name: COPY_KEYS.HEADINGS.ASSETS, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSETS] },
    { name: COPY_KEYS.HEADINGS.ASSET_NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSET_NAME] },
    { name: COPY_KEYS.HEADINGS.CURRENT_ORDER, value: "Current Order" },
    { name: COPY_KEYS.HEADINGS.ORDER, value: "Order" },
    { name: COPY_KEYS.HEADINGS.ORDERS, value: "Orders" },
    { name: COPY_KEYS.HEADINGS.CUSTOMER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.CUSTOMER] },
    { name: COPY_KEYS.HEADINGS.SITE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.SITE] },
    { name: COPY_KEYS.HEADINGS.NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.NAME] },
    { name: COPY_KEYS.HEADINGS.TYPE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.TYPE] },
    { name: COPY_KEYS.HEADINGS.STATUS, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.STATUS] },
    { name: COPY_KEYS.HEADINGS.ACTIONS, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ACTIONS] },
    // Messages
    { name: COPY_KEYS.MESSAGES.CREATED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.CREATED] },
    { name: COPY_KEYS.MESSAGES.UPDATED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATED] },
    { name: COPY_KEYS.MESSAGES.DELETED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.DELETED] },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED],
    },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED],
    },
    {
      name: COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED],
    },
    { name: COPY_KEYS.MESSAGES.CREATION_FAILED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.CREATION_FAILED] },
    { name: COPY_KEYS.MESSAGES.UPDATE_FAILED, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATE_FAILED] },
    { name: COPY_KEYS.MESSAGES.VALIDATION_ERROR, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.VALIDATION_ERROR] },
    { name: COPY_KEYS.MESSAGES.UNEXPECTED_ERROR, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UNEXPECTED_ERROR] },
    {
      name: COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME],
    },
    { name: COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM] },
    {
      name: COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM],
    },
    // Forms
    { name: COPY_KEYS.FORMS.PLEASE_PROVIDE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_PROVIDE] },
    { name: COPY_KEYS.FORMS.PLEASE_SELECT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLEASE_SELECT] },
    { name: COPY_KEYS.FORMS.ENTER, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.ENTER] },
    { name: COPY_KEYS.FORMS.INFORMATION_BELOW, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.INFORMATION_BELOW] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_CREATE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_CREATE] },
    { name: COPY_KEYS.FORMS.HELPER_TEXT_EDIT, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.HELPER_TEXT_EDIT] },
    {
      name: COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME,
      value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME],
    },
    { name: COPY_KEYS.FORMS.NOT_APPLICABLE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.FORMS.NOT_APPLICABLE] },
    // Labels
    { name: COPY_KEYS.LABELS.NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.NAME] },
    { name: COPY_KEYS.LABELS.TYPE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.TYPE] },
    { name: COPY_KEYS.LABELS.VOLUME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.VOLUME] },
    { name: COPY_KEYS.LABELS.MIN_PRESSURE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.MIN_PRESSURE] },
    { name: COPY_KEYS.LABELS.ASSET, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.ASSET] },
    { name: COPY_KEYS.LABELS.ASSET_NAME, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.LABELS.ASSET_NAME] },
    // Actions
    { name: COPY_KEYS.ACTIONS.CREATING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.CREATING] },
    { name: COPY_KEYS.ACTIONS.UPDATING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.UPDATING] },
    { name: COPY_KEYS.ACTIONS.DELETING, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.ACTIONS.DELETING] },
    // Common
    { name: COPY_KEYS.COMMON.A, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.A] },
    { name: COPY_KEYS.COMMON.AN, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.AN] },
    { name: COPY_KEYS.COMMON.THE, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.THE] },
    { name: COPY_KEYS.COMMON.AND, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.AND] },
    { name: COPY_KEYS.COMMON.TO_THE_SYSTEM, value: DEFAULT_COPY_MAPPINGS[COPY_KEYS.COMMON.TO_THE_SYSTEM] },
  ],
  statuses: [],
}

// const fleet = {
//   base: "vehicles",
//   name: "Vehicles",
//   type: "assets",
//   routes: [],
//   buttons: [{ name: "create", label: "Create Vehicle", description: "Add a new vehicle to the system" }],
//   headings: [
//     { name: "asset", value: "Vehicle" },
//     { name: "asset_name", value: "Vehicle Name" },
//     { name: "timestamp", value: "Timestamp" },
//     { name: "site", value: "Zone" },
//     { name: "name", value: "Name" },
//     { name: "type", value: "Type" },
//     { name: "status", value: "Status" },
//     { name: "amount", value: "Amount (pressure)" },
//     { name: "run_dry", value: "Run Dry" },
//     { name: "location", value: "Current Location" },
//     { name: "actions", value: "Actions" },
//     { name: "note", value: "Note" },
//   ],
//   statuses: [
//     {
//       type: "ASSET",
//       status: "available",
//       value: "Availableeeee",
//     },
//   ],
// }

export const HEADINGS = COPY_KEYS.HEADINGS.SITE

export default copy
